import React from 'react'
import PropTypes from 'prop-types'
import { Text, Box } from '@chatterbug/aaron'
import { Modal } from '@chatterbug/aaron/modal'
import { t } from 'src/lib/i18n-react'

import CopyToClipboard from 'src/components/CopyToClipboard'

const customStyle = {
  content: {
    borderRadius: '16px',
    maxWidth: '600px',
  },
}
const bodyParagraph = t(
  // eslint-disable-next-line no-multi-str
  'You can sync all your appointments to the calendar app of your choice.\
  This works with apps like Google Calendar Outlook, Apple Calendar, and many more.\
  Importing your iCalendar url below into these programs will allow them to show your appointments and update when your appointments change.'
)

const SyncToCalendar = ({ isOpen = false, onClose, iCalUrl }) => {
  return (
    <Modal
      onRequestClose={onClose}
      style={customStyle}
      isOpen={isOpen}
      title={t('Add appointments to your calendar')}
    >
      <Text mb="2x">{bodyParagraph}</Text>
      {/* copyValue=""@base_url + ical_path */}
      <CopyToClipboard
        copyId="ical-copy"
        copyValue={`${window.location.origin}${iCalUrl}`}
      />
      <Text my="2x">
        {t('Here are instructions for importing into popular apps:')}
      </Text>
      <Box as="ul" pr="0">
        <Box as="li">
          <Box
            as="a"
            color="blue30"
            sx={{
              textDecoration: 'underline',
              ':hover, :focus': {
                color: 'black',
              },
            }}
            href="https://support.google.com/calendar/answer/37100"
            target="_blank"
          >
            {'Google Calendar'}
          </Box>
          <Box as="span" ml="1x">
            {t('(see "Add using a link")')}
          </Box>
        </Box>
        <Box as="li">
          <Box
            as="a"
            color="blue30"
            sx={{
              textDecoration: 'underline',
              ':hover, :focus': {
                color: 'black',
              },
            }}
            href="https://support.office.com/en-us/article/Import-or-subscribe-to-a-calendar-in-Outlook-com-or-Outlook-on-the-web-CFF1429C-5AF6-41EC-A5B4-74F2C278E98C"
            target="_blank"
          >
            {'Outlook'}
          </Box>
        </Box>
        <Box as="li">
          <Box
            as="a"
            color="blue30"
            sx={{
              textDecoration: 'underline',
              ':hover, :focus': {
                color: 'black',
              },
            }}
            href="https://support.apple.com/kb/PH11523"
            target="_blank"
          >
            {'Apple Calendar'}
          </Box>
        </Box>
      </Box>
      <Box
        bg="red87"
        mt={{ _: '1x', tablet: '2x' }}
        p={{ _: '1x', tablet: '2x' }}
        textAlign="center"
        borderRadius="0,5x"
      >
        {t(
          'Warning! With Google Calendar, changes often take up to 24 hours to appear.'
        )}
      </Box>
    </Modal>
  )
}

SyncToCalendar.propTypes = {
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  iCalUrl: PropTypes.string.isRequired,
}
export default SyncToCalendar
